/* ── Panel shell ─────────────────────────────────────────── */
.panel {
  width: 0;
  min-width: 0;
  overflow: hidden;
  border-left: 1px solid transparent;
  background: var(--color-surface);
  transition: width 0.25s ease, min-width 0.25s ease, border-color 0.25s ease;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}

.panelOpen {
  width: 380px;
  min-width: 380px;
  border-left-color: var(--color-border);
}

.panelEmbedded {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: var(--color-surface);
}

.inner {
  width: 380px;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.panelEmbedded .inner {
  width: 100%;
}

/* ── Header ──────────────────────────────────────────────── */
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 var(--sp-4);
  height: 48px;
  border-bottom: 1px solid var(--color-border);
  flex-shrink: 0;
}

.headerLeft { display: flex; align-items: center; }
.headerRight { display: flex; align-items: center; gap: var(--sp-2); }

.panelTitle {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  font-family: var(--font-mono);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--color-sky);
}

.titleIcon { font-size: 14px; }

.modeBadge {
  margin-left: var(--sp-2);
  padding: 2px 6px;
  border-radius: var(--radius-sm);
  font-family: var(--font-mono);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  background: rgba(245, 158, 11, 0.15);
  color: var(--color-warn);
  border: 1px solid rgba(245, 158, 11, 0.3);
}

.modeLabelInline {
  margin-left: var(--sp-2);
  padding: 1px 5px;
  border-radius: var(--radius-sm);
  font-family: var(--font-mono);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  background: rgba(245, 158, 11, 0.12);
  color: var(--color-warn);
}

.toolRunning {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  margin-top: var(--sp-2);
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--color-text-muted);
}

.toolDot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--color-warn);
  animation: pulse-ring 1.2s ease-in-out infinite;
  flex-shrink: 0;
}

.backBtn {
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: var(--color-text-muted);
  background: none;
  padding: 4px var(--sp-2);
  border-radius: var(--radius-sm);
  transition: color 0.15s, background 0.15s;
}

.backBtn:hover { color: var(--color-sky); background: rgba(56, 189, 248, 0.07); }

.newBtn {
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: var(--color-sky);
  background: rgba(56, 189, 248, 0.08);
  border: 1px solid rgba(56, 189, 248, 0.2);
  padding: 4px var(--sp-3);
  border-radius: var(--radius-sm);
  transition: background 0.15s, border-color 0.15s;
}

.newBtn:hover { background: rgba(56, 189, 248, 0.14); border-color: rgba(56, 189, 248, 0.35); }

.shareBtn {
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: var(--color-text-faint);
  background: none;
  padding: 4px var(--sp-2);
  border-radius: var(--radius-sm);
  margin-left: auto;
  transition: color 0.15s, background 0.15s;
}

.shareBtn:hover { color: var(--color-sky); background: rgba(56, 189, 248, 0.07); }

.shareBtnOn {
  color: var(--color-teal-bright) !important;
}

.closeBtn {
  font-size: 14px;
  color: var(--color-text-faint);
  background: none;
  padding: 4px 6px;
  border-radius: var(--radius-sm);
  line-height: 1;
  transition: color 0.15s, background 0.15s;
}

.closeBtn:hover { color: var(--color-text); background: rgba(255,255,255,0.06); }

/* ── Conversation list ───────────────────────────────────── */
.listScroll {
  flex: 1;
  overflow-y: auto;
  padding: var(--sp-2) 0;
}

.emptyList {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--sp-4);
  padding: var(--sp-16) var(--sp-6);
  text-align: center;
}

.emptyListIcon {
  font-size: 32px;
  color: var(--color-sky);
  opacity: 0.2;
}

.emptyListText {
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--color-text-faint);
  letter-spacing: 0.3px;
}

.emptyNewBtn {
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--color-sky);
  background: rgba(56, 189, 248, 0.08);
  border: 1px solid rgba(56, 189, 248, 0.2);
  padding: var(--sp-3) var(--sp-4);
  border-radius: var(--radius-md);
  transition: background 0.15s;
}

.emptyNewBtn:hover { background: rgba(56, 189, 248, 0.14); }

/* ── Groups ──────────────────────────────────────────────── */
.group { padding: var(--sp-2) 0; }

.groupLabel {
  font-family: var(--font-mono);
  font-size: 9.5px;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--color-text-faint);
  padding: var(--sp-1) var(--sp-4) var(--sp-2);
}

/* ── Conversation item ───────────────────────────────────── */
.convItem {
  position: relative;
  display: block;
  width: 100%;
  text-align: left;
  padding: var(--sp-3) var(--sp-4);
  background: none;
  border-radius: 0;
  transition: background 0.12s;
  cursor: pointer;
}

.convItem:hover { background: rgba(56, 189, 248, 0.05); }

.convActive { background: rgba(56, 189, 248, 0.08) !important; }

.convRow {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--sp-2);
  margin-bottom: 3px;
}

.convTitle {
  font-family: var(--font-mono);
  font-size: 12.5px;
  font-weight: 600;
  color: var(--color-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}

.convTime {
  font-family: var(--font-mono);
  font-size: 10px;
  color: var(--color-text-faint);
  white-space: nowrap;
  flex-shrink: 0;
}

.convPreview {
  font-size: 12px;
  color: var(--color-text-muted);
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: var(--sp-5);
}

.sharedTag {
  display: inline-block;
  margin-top: 4px;
  font-family: var(--font-mono);
  font-size: 9.5px;
  letter-spacing: 0.5px;
  color: var(--color-teal-bright);
  background: rgba(45, 212, 191, 0.08);
  border: 1px solid rgba(45, 212, 191, 0.2);
  border-radius: 10px;
  padding: 1px 6px;
}

.deleteBtn {
  position: absolute;
  top: 50%;
  right: var(--sp-3);
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: none;
  color: var(--color-text-faint);
  font-size: 16px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.15s, color 0.15s, background 0.15s;
}

.convItem:hover .deleteBtn { opacity: 1; }
.deleteBtn:hover { color: var(--color-error); background: rgba(239, 68, 68, 0.1); }

/* ── Team section ────────────────────────────────────────── */
.teamHint {
  padding: var(--sp-3) var(--sp-4);
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--color-text-faint);
  line-height: 1.6;
  letter-spacing: 0.2px;
  border: 1px dashed var(--color-border);
  border-radius: var(--radius-md);
  margin: 0 var(--sp-4) var(--sp-3);
}

.teamBadge {
  font-family: var(--font-mono);
  font-size: 10px;
  color: var(--color-text-faint);
  background: rgba(255,255,255,0.05);
  border-radius: 4px;
  padding: 1px 5px;
}

/* ── Chat title bar ──────────────────────────────────────── */
.chatTitleBar {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  padding: var(--sp-2) var(--sp-4);
  border-bottom: 1px solid var(--color-border);
  flex-shrink: 0;
}

.chatTitle {
  font-family: var(--font-mono);
  font-size: 11.5px;
  font-weight: 600;
  color: var(--color-text-muted);
  letter-spacing: 0.3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

/* ── Thread ──────────────────────────────────────────────── */
.thread {
  flex: 1;
  overflow-y: auto;
  padding: var(--sp-4);
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
}

/* ── Empty / prompts state ───────────────────────────────── */
.emptyState {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--sp-4);
  padding: var(--sp-8) 0;
}

.emptyIcon {
  font-size: 28px;
  color: var(--color-sky);
  opacity: 0.25;
}

.emptyLabel {
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--color-text-faint);
}

.chips {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
  width: 100%;
}

.chip {
  text-align: left;
  padding: var(--sp-3) var(--sp-4);
  background: var(--color-surface-2);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  font-family: var(--font-sans);
  font-size: 12.5px;
  color: var(--color-text-muted);
  line-height: 1.5;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}

.chip:hover {
  background: rgba(56, 189, 248, 0.07);
  border-color: rgba(56, 189, 248, 0.25);
  color: var(--color-text);
}

/* ── Messages ────────────────────────────────────────────── */
.msg { display: flex; }
.msg.user { justify-content: flex-end; }
.msg.assistant { justify-content: flex-start; }

.userBubble {
  background: rgba(56, 189, 248, 0.1);
  border: 1px solid rgba(56, 189, 248, 0.22);
  border-radius: 12px 12px 2px 12px;
  padding: var(--sp-3) var(--sp-4);
  font-family: var(--font-mono);
  font-size: 12.5px;
  color: var(--color-sky);
  max-width: 85%;
  line-height: 1.5;
}

.assistantBubble {
  background: var(--color-bg);
  border: 1px solid var(--color-border);
  border-radius: 2px 12px 12px 12px;
  padding: var(--sp-4);
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
}

.aiLabel {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--color-sky);
}

.aiIcon { font-size: 12px; }

.aiAnswer { font-size: 13px; line-height: 1.7; color: var(--color-text); }
.aiAnswer strong { color: var(--color-sky); }
.aiAnswer p { margin: 0 0 0.6em; }
.aiAnswer p:last-child { margin-bottom: 0; }
.aiAnswer ul, .aiAnswer ol { padding-left: 1.4em; margin: 0 0 0.6em; }
.aiAnswer li { margin-bottom: 0.2em; }
.aiAnswer code { font-family: var(--font-mono); font-size: 12px; background: rgba(56,189,248,0.08); padding: 1px 5px; border-radius: 3px; }
.aiAnswer pre { background: rgba(56,189,248,0.05); border: 1px solid var(--color-border); border-radius: var(--radius-sm); padding: var(--sp-3); overflow-x: auto; margin: 0.4em 0 0.8em; }
.aiAnswer pre code { background: none; padding: 0; font-size: 12px; }

/* Markdown tables */
.aiAnswer table { border-collapse: collapse; font-size: 12px; width: 100%; margin: 0.4em 0 0.8em; }
.aiAnswer th, .aiAnswer td { padding: 5px 10px; border: 1px solid var(--color-border); text-align: left; white-space: nowrap; }
.aiAnswer th { background: rgba(56,189,248,0.06); color: var(--color-sky); font-weight: 600; letter-spacing: 0.03em; }
.aiAnswer tr:nth-child(even) td { background: rgba(255,255,255,0.02); }

/* Long table collapse */
.tableScroll { overflow: hidden; }
.tableScroll table { margin-bottom: 0; }
.tableCollapsed { max-height: 220px; }

.tableShowMoreBtn {
  display: block;
  width: 100%;
  margin: 0 0 0.8em;
  padding: 5px 0;
  font-family: var(--font-mono);
  font-size: 11px;
  letter-spacing: 0.03em;
  color: var(--color-sky);
  background: rgba(56,189,248,0.06);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  text-align: center;
  cursor: pointer;
  transition: background 0.15s;
}

.tableShowMoreBtn:hover { background: rgba(56,189,248,0.12); }

.sqlSection { display: flex; flex-direction: column; gap: var(--sp-2); }

.sqlToggle {
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--color-text-muted);
  background: none;
  text-align: left;
  padding: 0;
  letter-spacing: 0.5px;
  transition: color 0.15s;
}

.sqlToggle:hover { color: var(--color-sky); }

.sqlBlock {
  background: #020810;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: var(--sp-3);
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--color-teal-bright);
  overflow-x: auto;
  line-height: 1.7;
  white-space: pre;
  max-height: 180px;
  overflow-y: auto;
}

.sqlBlockList { display: flex; flex-direction: column; gap: var(--sp-2); }

.aiSource {
  font-family: var(--font-mono);
  font-size: 10px;
  color: var(--color-text-faint);
  letter-spacing: 0.3px;
}

.msgActions {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  margin-top: var(--sp-2);
}

.pinBtn {
  font-family: var(--font-mono);
  font-size: 10px;
  color: var(--color-text-faint);
  background: transparent;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  padding: 2px var(--sp-2);
  transition: color 0.15s, border-color 0.15s;
}

.pinBtn:hover { color: var(--color-sky); border-color: rgba(56,189,248,0.3); }

.pinBtnDone {
  color: var(--color-teal-bright) !important;
  border-color: rgba(20,184,166,0.3) !important;
}

/* ── Nango OAuth authorize button ────────────────────────── */
.nangoAuthCard {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  margin: var(--sp-2) var(--sp-3);
  padding: var(--sp-2) var(--sp-3);
  background: rgba(20,184,166,0.06);
  border: 1px solid rgba(20,184,166,0.2);
  border-radius: var(--radius-md);
}

.nangoAuthLabel {
  font-size: 12px;
  color: var(--color-text-muted);
  flex: 1;
}

.nangoAuthBtn {
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 600;
  color: var(--color-teal-bright);
  background: rgba(20,184,166,0.12);
  border: 1px solid rgba(20,184,166,0.3);
  border-radius: var(--radius-sm);
  padding: 4px 10px;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
  white-space: nowrap;
}

.nangoAuthBtn:hover {
  background: rgba(20,184,166,0.22);
  border-color: rgba(20,184,166,0.5);
}

/* ── Thinking dots ───────────────────────────────────────── */
.thinking {
  display: flex;
  gap: 5px;
  align-items: center;
  padding: var(--sp-1) 0;
}

.thinking span {
  display: block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--color-sky);
  animation: blink 1.2s ease infinite;
}

.thinking span:nth-child(2) { animation-delay: 0.2s; }
.thinking span:nth-child(3) { animation-delay: 0.4s; }

/* ── Token warning banner ────────────────────────────────── */
.tokenWarning {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-2);
  margin: 0 var(--sp-4);
  padding: var(--sp-2) var(--sp-3);
  background: rgba(234, 179, 8, 0.08);
  border: 1px solid rgba(234, 179, 8, 0.25);
  border-radius: var(--radius-md);
}

.tokenWarningText {
  font-family: var(--font-mono);
  font-size: 11px;
  color: rgb(234, 179, 8);
  line-height: 1.4;
}

.tokenWarningDismiss {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border-radius: var(--radius-sm);
  background: transparent;
  color: rgba(234, 179, 8, 0.6);
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tokenWarningDismiss:hover { color: rgb(234, 179, 8); }

/* ── Footer / input ──────────────────────────────────────── */
.footer {
  flex-shrink: 0;
  padding: var(--sp-3) var(--sp-4) var(--sp-4);
  border-top: 1px solid var(--color-border);
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
}

.inputBox {
  display: flex;
  align-items: flex-end;
  gap: var(--sp-2);
  background: var(--color-bg);
  border: 1px solid var(--color-border-med);
  border-radius: var(--radius-lg);
  padding: var(--sp-3);
  transition: border-color 0.15s, box-shadow 0.15s;
}

.inputBox:focus-within {
  border-color: rgba(56, 189, 248, 0.4);
  box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.06);
}

.input {
  flex: 1;
  font-family: var(--font-mono);
  font-size: 13px;
  color: var(--color-text);
  resize: none;
  line-height: 1.6;
  min-height: 60px;
  max-height: 200px;
  overflow-y: auto;
}

.input::placeholder { color: var(--color-text-faint); }

.sendBtn {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-md);
  background: rgba(56, 189, 248, 0.08);
  color: var(--color-text-faint);
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 0.15s, color 0.15s;
}

.sendActive { background: var(--color-sky) !important; color: var(--color-bg) !important; }

.hint {
  font-family: var(--font-mono);
  font-size: 9.5px;
  color: var(--color-text-faint);
  letter-spacing: 0.5px;
  text-align: center;
}

/* ── File upload ─────────────────────────────────────────── */
.fileInput { display: none; }

.uploadBtn {
  width: 28px;
  height: 28px;
  border-radius: var(--radius-sm);
  background: transparent;
  border: 1px solid var(--color-border);
  color: var(--color-text-faint);
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s;
  line-height: 1;
}

.uploadBtn:hover:not(:disabled) {
  border-color: var(--color-border-med);
  color: var(--color-sky);
}

.uploadBtn:disabled { opacity: 0.35; cursor: default; }

.attachmentChip {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  padding: var(--sp-2) var(--sp-3);
  background: rgba(56,189,248,0.06);
  border: 1px solid rgba(56,189,248,0.2);
  border-radius: var(--radius-md);
  font-family: var(--font-mono);
}

.attachmentIcon { font-size: 12px; color: var(--color-sky); }

.attachmentName {
  font-size: 11px;
  color: var(--color-text);
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
}

.attachmentMeta { font-size: 10px; color: var(--color-text-faint); }

.attachmentRemove {
  background: none;
  border: none;
  color: var(--color-text-faint);
  font-size: 11px;
  cursor: pointer;
  padding: 0 2px;
  line-height: 1;
  transition: color 0.15s;
}

.attachmentRemove:hover { color: var(--color-error); }

.chartWrapper {
  position: relative;
  margin-top: 8px;
}

.chartWrapper:hover .chartExpandBtn {
  opacity: 1;
}

.chartExpandBtn {
  position: absolute;
  top: 8px;
  right: 8px;
  opacity: 0;
  transition: opacity 0.15s, background 0.15s;
  background: var(--color-surface, rgba(30,30,40,0.85));
  border: 1px solid var(--color-border, rgba(255,255,255,0.12));
  color: var(--color-text-muted, #aaa);
  border-radius: 5px;
  padding: 3px 7px;
  font-size: 14px;
  cursor: pointer;
  line-height: 1;
  backdrop-filter: blur(4px);
  z-index: 1;
}

.chartExpandBtn:hover {
  background: var(--color-hover, rgba(255,255,255,0.08));
  color: var(--color-text, #fff);
}

.chartContainer {
  width: 100%;
  min-height: 260px;
  border-radius: 6px;
  overflow: hidden;
}

/* ── Chart expand modal ── */
.chartModal {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(2px);
}

.chartModalContent {
  position: relative;
  background: var(--color-surface-raised, #1e1e2a);
  border: 1px solid var(--color-border, rgba(255,255,255,0.1));
  border-radius: 10px;
  padding: 40px 24px 24px;
  width: 90vw;
  max-width: 1200px;
  max-height: 90vh;
  overflow: auto;
  box-shadow: 0 24px 80px rgba(0,0,0,0.5);
}

.chartModalClose {
  position: absolute;
  top: 10px;
  right: 12px;
  background: transparent;
  border: none;
  color: var(--color-text-muted, #aaa);
  font-size: 16px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: color 0.15s, background 0.15s;
}

.chartModalClose:hover {
  color: var(--color-text, #fff);
  background: var(--color-hover, rgba(255,255,255,0.08));
}

.chartLoading {
  font-size: 11px;
  color: var(--color-text-faint);
  padding: 12px 0;
}

/* ── Awaiting server-side response (polling) ── */
.awaitingBanner {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--color-text-muted);
  padding: var(--sp-1) 0;
}

/* ── Tool step log ── */
.toolStepList {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: var(--sp-2) 0;
}
.toolStep {
  display: flex;
  align-items: center;
  gap: 7px;
  font-family: var(--font-mono);
  font-size: 11px;
}
.toolStepDone  { color: var(--color-success); font-size: 11px; flex-shrink: 0; }
.toolStepError { color: var(--color-error);   font-size: 11px; flex-shrink: 0; }
.toolStepLabelDone { color: var(--color-text-muted); }
.toolStepLabelRun  { color: var(--color-text); }
.toolStepLabelErr  { color: var(--color-error); }

/* ── Slack-style status strip ── */
.statusStrip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 16px;
  border-top: 1px solid var(--color-border);
  font-family: var(--font-mono);
  font-size: 11px;
  min-height: 34px;
  flex-shrink: 0;
}
.statusStripText { color: var(--color-text); }

/* ── Collapsed step summary on finished messages ── */
.stepSummaryWrap { margin: var(--sp-1) 0 var(--sp-2); }
.stepSummary {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--color-text-muted);
}
.stepSummary:hover { color: var(--color-text); }

/* ── File upload chip inside user bubble ── */
.fileUploadChip {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-2);
  padding: 4px 10px;
  background: rgba(56,189,248,0.08);
  border: 1px solid rgba(56,189,248,0.25);
  border-radius: var(--radius-md);
  font-family: var(--font-mono);
  margin-bottom: var(--sp-2);
}
.fileUploadIcon { font-size: 11px; color: var(--color-sky); }
.fileUploadName { font-size: 11px; font-weight: 600; color: var(--color-sky); }
.fileUploadMeta { font-size: 10px; color: var(--color-text-faint); }
.fileUploadQuery { font-size: 12px; color: var(--color-sky); margin-top: 2px; }
